import Vue from 'vue';
const alertEventBus = new Vue({
    methods:{
        setAlert(data){
            this.$emit('alert', data);
        },
        clearAlert(){
            this.$emit('clearAlert');
        },
        setLoading(){
            this.$emit('setLoading');
        },
        clearLoading(){
            this.$emit('clearLoading');
        }
    }
});

export default alertEventBus;